<template>
    <div class="text-center">
      <v-dialog persistent v-if="visible" v-model="visible" width="800">
        <v-card class="not-margin pt-0 pr-0 pl-0">
          <v-toolbar dark color="primary">
            <div class="text-center">
              <v-icon>mdi-pencil</v-icon>
              {{ edit ? "Editar" : "Cadastrar" }} Função
            </div>
          </v-toolbar>
          <div class="container dialog">
            <v-form ref="form">
              <v-row class="d-flex justify-center mt-7">
                <v-col cols="12">
                  <v-text-field
                    v-model="content.nome"
                    label="Nome da função*"
                    counter="32"
                    maxlength="32"
                    outlined
                    dense
                    :rules="[(v) => $required(v), (v) => $max(v, 32)]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  Tipo do Profissional*
                  <v-radio-group
                    v-model="content.servidorDoEstado"
                    :rules="[v => v !== null || 'Campo obrigatório']"
                    outlined
                    dense
                  >
                    <v-radio
                      label="Servidor do Estado de PE"
                      :value="true"
                    ></v-radio>
                    <v-radio
                      label="Profissional externo"
                      :value="false"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="content.atividades"
                    label="Atividades"
                    outlined
                    dense
                    rows="4"
                    maxlength="2500"
                    counter
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
            <div class="alert-message d-flex align-center mt-4">
                <v-icon color="warning" class="mr-2">mdi-alert-circle</v-icon>
                <span>Os campos marcados com asterisco(*) são obrigatórios</span>
              </div>
          </div>
          <sca-buttons
            @click="salvar()"
            @cancel="$emit('onClose')"
            :actionText="edit ? 'Editar' : 'Salvar'"
          ></sca-buttons>
        </v-card>
      </v-dialog>
    </div>
  </template>

  <script>
  import { DialogProps } from '~/commons/classes/dialog-props';
  import { Funcao } from '~/commons/classes/funcao';
  import FuncaoService from '~/services/funcao.service';

  export default {
    props: new DialogProps(Funcao),
    mixins: [FuncaoService],
    data: () => ({
      form: {
        nome: null,
        servidorDoEstado: null,
        lists: {
        },
      },
    }),
    methods: {
      salvar() {
        const save = () => {
          return this.$swal({
            text: `Deseja ${this.edit ? "editar" : "cadastrar"} o registro?`,
            type: "warning",
            showCancelButton: true,
            confirmButtonText: `Confirmar`,
            cancelButtonText: `Cancelar`,
          }).then(() => {
            const funcao = new Funcao(this.content);
            return this.edit
              ? this.$editarFuncao(funcao, funcao.id)
              : this.$cadastrarFuncao(funcao);
          });
        };
        if (this.$validarFormulario('Todos os campos obrigatórios devem ser preenchidos.')) {
          save().then(({ data }) => {
            this.$notifySuccess(data.mensagem);
            this.$emit("onClose");
            this.$emit("onSave");
          });
        }
      }
    },
    mounted() {
    },
  };
  </script>
